/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Header, Segment, } from 'semantic-ui-react';
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder';
import Axios from 'axios';
import APP_CONSTANTS from '../../../config/constants';
import VehActionButton from './vehActionButton';
import TyreRenderer from './tyreRenderer';
import BatteryRenderer from './batteryRenderer';
import AgGridTable from '../../agGridComponent/agGridTable';
import moment from 'moment';
import { FEATURES } from '../../../utils/constants';

function VehicleTable(props) {
    const [vehs, setvehs] = useState([])
    const [isLoaded, setisLoaded] = useState(false)
    const [isUpdated, setisUpdated] = useState(false)

    useEffect(() => {
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')

        let vehicleData = {
            "userId": userId,
            "customerNumber": customerNo
        }

        Axios.post(`${APP_CONSTANTS.BASE_URL}masters/vehicleMaster`, vehicleData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setvehs(response.data.resultSet);
            setisLoaded(true);
        }))
        .catch(error => {
            console.log(error);
            setisLoaded(true);
        })
    }, [])


    let getUpdate = (data) => {
        if (data) {
            setisUpdated(!isUpdated)
        }
    }
    
    if (vehs.length === 0 && isLoaded === false) {
        return (
            <LoadingPlaceholder />
        )
    } else {

        let columnDefs = [
            { headerName: 'Vehicle No.', field: 'vehnumber', tooltipField: 'vehnumber', enableRowGroup: true, enablePivot: true, filter: true},
            { headerName: 'Vehicle Type', field: 'type', tooltipField: 'type', enableRowGroup: true, enablePivot: true, filter: true },
            { hide: true, headerName:'Make', field: 'make',  filter: 'agTextColumnFilter', width: 150 },
            { hide: true, headerName:'Model', field: 'model',  filter: 'agTextColumnFilter', width: 150 },
            { hide: true, headerName:'Manufacturing Date', field: 'manufacturingdate',  filter: 'agTextColumnFilter', width: 150 },        
            { headerName: 'Chassis No.', field: 'chassis', tooltipField: 'chassis', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Branch', field: 'branch', tooltipField: 'branch', enableRowGroup: true, enablePivot: true, filter: true, },
            { hide: true, headerName:'Purchase Date', field: 'purchasedate',  filter: 'agTextColumnFilter', width: 150 },        
            { hide: true, headerName:'Registration Date', field: 'registrationdate',  filter: 'agTextColumnFilter', width: 150 },
            { hide: true, headerName:'Fuel Tank Capacity', field: 'fueltankcapacity',  filter: 'agTextColumnFilter', width: 150 },  
            { hide: true, headerName:'RTO Location', field: 'rtolocation',  filter: 'agTextColumnFilter', width: 150 },  
            { hide: true, headerName:'Engine Number', field: 'enginenumber',  filter: 'agTextColumnFilter', width: 150 },   
                               
            { headerName: 'Vendor', field: 'vendor', tooltipField: 'vendor', enableRowGroup: true, enablePivot: true, filter: true, },
            { headerName: 'Vehicle Ownership', field: 'vehicleownership', tooltipField: 'vehicleownership', enableRowGroup: true, enablePivot: true, filter: true, }, 
            { hide: true, headerName:'Insurance Company', field: 'insurancecompany',  filter: 'agTextColumnFilter', width: 150 },        
            { hide: true, headerName:'Value of Insurance', field: 'valueofinsurance',  filter: 'agTextColumnFilter', width: 150 },
            { hide: true, headerName:'Premium', field: 'premium',  filter: 'agTextColumnFilter', width: 150 },
            { hide: true, headerName:'Place of Claim', field: 'placeofclaim',  filter: 'agTextColumnFilter', width: 150 },
            { hide: true, headerName:'Insurance Vendor', field: 'insurancevendor',  filter: 'agTextColumnFilter', width: 150 },
            { hide: true, headerName:'Policy Number', field: 'policynumber',  filter: 'agTextColumnFilter', width: 150 },
            { hide: true, headerName:'Notes', field: 'notes',  filter: 'agTextColumnFilter', width: 150 },
            { headerName: 'Created By', field: 'cby', tooltipField: 'cdate', enableRowGroup: true, enablePivot: true, filter: true, },
            { headerName: 'Created Date', field: 'cdate', tooltipField: 'cdate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Updated By', field: 'uby', tooltipField: 'uby', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Updated Date', field: 'udate', tooltipField: 'udate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Tyre', field: 'tyre', enableRowGroup: true, enablePivot: true, cellRenderer: 'tyreRenderer', maxWidth: "20px", pinned: "right" },
            { headerName: 'Battery', field: 'battery', enableRowGroup: true, enablePivot: true, cellRenderer: 'batteryRenderer', width: "20px", pinned: "right" },
            { headerName: 'Edit / Delete', field: 'edit', cellRenderer: 'actionRenderer', pinned: "right" },
        ]
        let rowData = []
        vehs.map((object, i) => {
            console.log(object,'obj')
            let temp = {}
            temp.vehnumber = object.vehicleNumber
            temp.type = object.vehicleType ? object.vehicleType : ''
            temp.chassis = object.chassisNo ?  object.chassisNo.toUpperCase() : ""
            temp.branch = object.branchName
            temp.vendor = object.transporterName
            temp.vehicleownership = object.vehicleOwner
            temp.id = object.vehicleMasterId
            temp.cby = object.createdByName
            temp.cdate = object.createdOn ? moment(object.createdOn).format('DD-MM-yyyy') : null
            temp.uby = object.updatedByName
            temp.tyers = object.vehicle_tyre
            temp.battery = object.batterySerialNo
            temp.batteryInstallationDate = object.batteryInstallationDate
            // temp.udate = object.updatedOn ? moment(object.updatedOn).format('DD-MM-yyyy') : null
            temp.udate = object.updatedOn == '0000-00-00 00:00:00' ? null : moment(object.updatedOn).format('DD-MM-yyyy')
            temp.customerNo = object.customerNo
            temp.make = object.vehicleMake
            temp.model = object.vehicleModel
            temp.manufacturingdate = object.manufactureDate
            temp.purchasedate = object.purchaseDate
            temp.registrationdate = object.regdate
            temp.fueltankcapacity = object.fuelTankCapacity
            temp.rtolocation = object.rtoLocation
            temp.enginenumber = object.engineNo ? object.engineNo.toUpperCase() : ""
            temp.insurancecompany = object.insuranceVendorName
            temp.valueofinsurance = object.valueOfInsurance
            temp.premium = object.insPremium
            temp.placeofclaim = object.insPlaceOfClain
            temp.insurancevendor = object.insuranceVendorName
            temp.policynumber = object.insPolicyNo ? object.insPolicyNo.toUpperCase() : ""
            temp.notes = object.insNote


            rowData[i] = temp
            
        })



        let frameworkComponents = {
            actionRenderer: VehActionButton,
            tyreRenderer: TyreRenderer,
            batteryRenderer: BatteryRenderer,
            locationInfo: props.location
        }
        return (
            <React.Fragment >
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    extraComponents={frameworkComponents}
                    reload={getUpdate}
                    hiddenNewPopupBtn={true}
                    hiddenImportPopupBtn={false}
                    importLink="/import-vehicle"
                    link="/add-vehicle"
                    titleBarTitle="Vehicle"
                    handleSearch={props.handleSearch}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
        )
    }

}

export default VehicleTable
